export default __webpack_public_path__ + "static/media/0019.5c5652a2.png";